var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.82812,
    y: 0.757324,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(45 7.82812 0.757324)",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.24219,
    y: 7.82861,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(135 9.24219 7.82861)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.ca309f66bc7b8031f69855e0fd22b550.svg";
export { ForwardRef as ReactComponent };